// extracted by mini-css-extract-plugin
export var caretAnchor = "_vi-0";
export var dropdownContent = "_vi-1";